import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';

import { Driver } from '../../../../commons/models/domain/Driver';



@Component({
    selector: 'wm-driver-details-tabs',
    styleUrls: ['./driver-details-tabs.component.less'],
    templateUrl: './driver-details-tabs.component.html'
})
export class DriverDetailsTabsComponent implements OnChanges {

    /**
     *
     */
    @Input() public driver?: Driver;

    /**
     *
     */
    public tab: string = 'data';


    constructor() { }

  ngOnChanges(changes: SimpleChanges): void {
    console.debug('DriverDetailsTabsComponent:' + this.driver);
  }
}
